// PRODUCT BOOST
export const RESET_PRODUCT_BOOSTED_DATA = 'RESET_PRODUCT_BOOSTED_DATA';
// POINT OF SALE
export const POINT_OF_SALE_LIST_SUCCESS = 'POINT_OF_SALE_LIST_SUCCESS';
export const POINT_OF_SALE_SETTINGS_SUCCESS = 'POINT_OF_SALE_SETTINGS_SUCCESS';

// SALE RATE
export const SALE_RATE_LIST_SUCCESS = 'SALE_RATE_LIST_SUCCESS';

// MASTER SALE FORMAT
export const MASTER_SALE_FORMAT_LIST_SUCCESS = 'MASTER_SALE_FORMAT_LIST_SUCCESS';

// PREDICTION PERIOD
export const PREDICTION_PERIOD_LIST_SUCCESS = 'PREDICTION_PERIOD_LIST_SUCCESS';
export const PREDICTION_PERIOD_SUCCESS = 'PREDICTION_PERIOD_SUCCESS';
export const VALIDATE_PERIOD_PRICES = 'VALIDATE_PERIOD_PRICES';
export const VALIDATE_PERIOD_DEMAND = 'VALIDATE_PERIOD_DEMAND';
export const VALIDATE_PERIOD_ENGINEERING = 'VALIDATE_PERIOD_ENGINEERING';

// SERVICE
export const SERVICE_LIST_SUCCESS = 'SERVICE_LIST_SUCCESS';

// NEW PRODUCTS
export const NEW_PRODUCTS_SUCCESS = 'NEW_PRODUCTS_SUCCESS';
export const MODIFY_NEW_PRODUCTS = 'MODIFY_NEW_PRODUCTS';

// RECURSIVE
export const RESET_POINT_OF_SALE_STATE = 'RESET_POINT_OF_SALE_STATE';

// PRODUCT
export const MASTER_PRODUCT_LIST_TOKEN = 'MASTER_PRODUCT_LIST_TOKEN';
export const MASTER_PRODUCT_LIST_UPDATE = 'MASTER_PRODUCT_LIST_UPDATE';
export const MASTER_PRODUCT_UPDATE = 'MASTER_PRODUCT_UPDATE';
export const MASTER_PRODUCT_LIST_SUCCESS = 'MASTER_PRODUCT_LIST_SUCCESS';
export const MASTER_PRODUCT_LIST_ERROR = 'MASTER_PRODUCT_LIST_ERROR';
export const MASTER_PRODUCT_SALE_FORMAT_SUCCESS = 'MASTER_PRODUCT_SALE_FORMAT_SUCCESS';

// GROUP OF PRODUCTS PRICING
export const GROUP_OF_PRODUCT_PRICING_LIST_SUCCESS = 'GROUP_OF_PRODUCT_PRICING_LIST_SUCCESS';

// MENU LIST
export const MENU_LIST_SUCCESS = 'MENU_LIST_SUCCESS';
// CREATE MENU
export const CREATE_MENU_SUCCESS = 'CREATE_MENU_SUCCESS';
// EDIT MENU
export const EDIT_MENU_SUCCESS = 'EDIT_MENU_SUCCESS';
export const UPDATE_MENU_PUBLICATION = 'UPDATE_MENU_PUBLICATION';
// DELETE MENU
export const DELETE_MENU_SUCCESS = 'DELETE_MENU_SUCCESS';
